import classNames from 'classnames'
import { MyImage } from '~/components/ui/MyImage'

/** 大赛信息统计 */
export const CompetitionDataInfo: React.FC<{
  /** 主办方信息 */
  host: string
  className?: string
}> = ({ host, className }) => {
  return (
    <div className={classNames('relative', className)}>
      <div className="flex">
        <div className="flex  items-center py-2 px-3 bg-neutral-900/[0.04]  rounded-xl  mr-8 ">
          <span className=" text-xs text-neutral-500 font-semibold mr-3">
            举办方
          </span>
          <div className="flex-1 flex">
            <MyImage
              src={host}
              tag="v400"
              className="min-w-[403px] h-12 rounded-[4px]"
              dark
            />
          </div>
        </div>
      </div>
    </div>
  )
}
